import { Component, inject } from '@angular/core';
import { PileStatusService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PileStatusCreateDto,
  PileStatusDto,
  PileStatusExcelDownloadDto,
  PileStatusUpdateDto,
} from '../proxy/planning/dtos/pile-status';
import { PILESTATUS_CONFIG, PILESTATUS_FIELDS } from './pile-status.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-pile-status',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PileStatusService, ConfirmationService],
  templateUrl: './pile-status.html',
  styleUrl: './pile-status.scss',
})
export class PileStatus extends BaseCrudComponent<
  PileStatusDto,
  PileStatusCreateDto,
  PileStatusUpdateDto,
  PileStatusExcelDownloadDto
> {
  service = inject(PileStatusService);
  config = PILESTATUS_CONFIG;
  fields = PILESTATUS_FIELDS;

  protected prepareUpdateDto(data: any, selected: PileStatusDto): PileStatusUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PileStatus';
  }
}
